import { gql, useMutation, MutationHookOptions } from "@apollo/client";

export interface DeleteExternalTransactionMutationVariables {
  id: string;
}

export interface DeleteExternalTransactionMutationResult {
  deleteExternalTransaction: {
    success: boolean;
  };
}

export const DELETE_EXTERNAL_TRANSACTION_MUTATION = gql`
  mutation deleteExternalTransaction($id: String!) {
    deleteExternalTransaction(id: $id) {
      success
    }
  }
`;

export const useDeleteExternalTransactionMutation = (
  options?: MutationHookOptions<
    DeleteExternalTransactionMutationResult,
    DeleteExternalTransactionMutationVariables
  >
) => {
  return useMutation<
    DeleteExternalTransactionMutationResult,
    DeleteExternalTransactionMutationVariables
  >(DELETE_EXTERNAL_TRANSACTION_MUTATION, options);
};
